import { setToken, setRefreshToken, removeToken, removeRefreshToken } from './token';
import { resetAuthState } from './request';
import '../plugins/method.js';



/**
 *系統登录
 * @param {Object} that
 * @param {Object} myUrl
 * @param {Object} data
 * @param {Object} callback
 */
window.ajaxDingDingLogin = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.get(myUrl, data, {
      that: that
    })
    if (res.success) {
      removeToken();
      removeRefreshToken();
      that.$nextTick(() => {
        // 兼容两种返回结构：res.data.token.accessToken 和 res.data.accessToken
        setToken(res.data.accessToken);
        setRefreshToken(res.data.refreshToken);
        resetAuthState(); // 重置 isRedirecting/loginMessageShown，为下次刷新周期做准备
        callback(res);

      });
    } else {
      callback(res);
    }
  } catch (err) {
    error(that, err.message)
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxDingDingLogin', err.message, myUrl, data, err.stack.toString()); // 记录日志
  }
};

/**
 *
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPostVali = async function (that, myUrl, data, callback) {
  try {
    if (myUrl != null && typeof (myUrl) != "undefined" && myUrl != "") {
      const res = await that.$request.post(myUrl, data, {
        that: that
      });
      that.$nextTick(() => {
        if (res.success == true) {
          callback(res.data);
        } else {
          that.fullscreenLoading = false;
          recordLog(that, 3, 'POST/ajaxPostVali', res.message, myUrl, res, data); // 记录日志
        }
      })
    }
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPostError', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};


/**
 * 系統登录
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxLogin = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post('/api/auth/token', data, { that: that });
    if (res.data.success) {
      removeToken();
      removeRefreshToken();
      that.$nextTick(() => {
        setToken(res.data.token.accessToken);
        setRefreshToken(res.data.token.refreshToken);
        resetAuthState(); // 重置 isRedirecting/loginMessageShown，为下次刷新周期做准备
        callback(res);
      });
    } else {
      callback(res);
    }
  } catch (err) {
    error(that, err.message)
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxLogin', err.message, myUrl, data, err.stack.toString()); // 记录日志
  }
};


/**
 * @description 以get方式访问接口，查询
 * @param {Object} that this
 * @param {Object} myUrl 接口地址
 * @param {Object} data 参数
 * @param {Object} callback 回调
 */
window.ajaxGetNoToken = function (that, myUrl, data, callback) {
  if (!regNull(myUrl)) {
    that.$axios.get(
      myUrl, {
      params: data,
    }
    ).then(res => {
      res.data.success == true ? callback(res.data.data) : warning(that, res.data.message);
    }).catch(err => {
      error(that, err.message);
      that.fullscreenLoading = false;
      recordLog(that, 3, 'GET/ajaxGetNoToken', err.message, myUrl, err.stack.toString(), data); // 记录日志
    });
  }
};




/**
 * 以get方式访问接口，查询
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxGet = async function (that, myUrl, data, callback) {
  try {
    if (myUrl != null && typeof (myUrl) != "undefined" && myUrl != "") {
      const res = await that.$request.get(myUrl, {
        params: data,
        that: that
      })
      that.$nextTick(() => {
        if (!regNull(res)) {
          if (res.success == true) {
            callback(res.data);
          } else {
            recordLog(that, 3, 'GET/ajaxGet', res.message, myUrl, res, data); // 记录日志
          }
        } else {
          that.fullscreenLoading = false;
        }
      });
    } else {
      that.fullscreenLoading = false;
    }
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'GET/ajaxGet', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};


/**
 * 以get方式导出文件（fileName要全称，包括扩展名）
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} fileName
 * @param {*} callback
 */
window.ajaxExport = async function (that, myUrl, data, fileName, callback) {
  try {
    if (myUrl != null && typeof (myUrl) != "undefined" && myUrl != "") {
      const res = await that.$request({
        method: 'get',
        url: myUrl,
        params: data,
        responseType: 'blob', // 正确的位置
        that: that
      })
      that.$nextTick(() => {
        // 处理返回的文件流
        //主要是将返回的data数据通过blob保存成文件
        var content = res;
        var blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          callback(res.data);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    } else {
      that.fullscreenLoading = false;
    }
  } catch (err) {
    error(that, err.message)
    that.fullscreenLoading = false;
    recordLog(that, 3, 'GET/ajaxExport', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};

/**
 * 以post方式访问接口，提交
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPost = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post(myUrl,
      data, {
      that: that
    }
    );
    if (res.success == true) {
      if (res.data.result == true) {
        var reg = new RegExp(/^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/);
        if (!reg.test(res.data.message)) {
          success(that, res.data.message);
        } else {
          success(that, "新增成功");
        }
        callback(res.data);
      } else {
        that.fullscreenLoading = false;
        warning(that, res.data.message);
        callback(res.data);
      }
    } else {
      that.fullscreenLoading = false;
      recordLog(that, 3, 'POST/ajaxPost', res.message, myUrl, res, data); // 记录日志
    }

  } catch (err) {
    error(that, err.message)
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPost', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};

/**
 * 上传
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxUpload = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post(myUrl, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      that: that
    })
    that.$nextTick(() => {
      if (res.success != false) {
        if (res.data.result == true) {
          success(that, res.data.message);
        } else {
          warning(that, res.data.message);
        }
        callback(res);
      } else {
        that.fullscreenLoading = false;
        recordLog(that, 3, 'POST/ajaxUpload', res.message, myUrl, res, data); // 记录日志
        callback(res);
      }
    });
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxUpload', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
};

/**
 * 以post方式导出文件 (fileName要全称，包括扩展名)
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} fileName
 * @param {*} callback
 */
window.ajaxPostExport = async function (that, myUrl, data, fileName, callback) {
  try {
    if (myUrl != null && typeof (myUrl) != "undefined" && myUrl != "") {
      const res = await that.$request.post(myUrl, {
        params: data,
        responseType: 'blob',
        'accept': 'text/plain',
      }, { that: that })
      that.$nextTick(() => {
        // 处理返回的文件流
        //主要是将返回的data数据通过blob保存成文件
        var content = res;
        var blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          callback(res.data);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    } else {
      that.fullscreenLoading = false;
      callback(null);
    }
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPostExport', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
};


/**
 * 以POST方式获取数据
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPostToGet = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post(myUrl, data, {
      that: that
    });
    that.$nextTick(() => {
      if (res.success == true) {
        callback(res.data);
      } else {
        that.fullscreenLoading = false;
        recordLog(that, 3, 'POST/ajaxPostToGet', res.message, myUrl, res, data); // 记录日志
        callback(res.data);
      }
    });
  } catch (err) {
    error(that, err.message)
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPostToGet', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
}


/**
 * 以put方式访问接口，修改
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPut = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.put(myUrl, data, {
      that: that
    });
    that.$nextTick(() => {
      if (res.success == true) {
        if (res.data.result == true) {
          var reg = new RegExp(/^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/);
          if (!reg.test(res.data.message)) {
            success(that, res.data.message);
          } else {
            success(that, "编辑成功");
          }
          callback(res.data);
        } else {
          that.fullscreenLoading = false;
          warning(that, res.data.message);
          callback(null);
        }
      } else {
        that.fullscreenLoading = false;
        recordLog(that, 3, 'PUT/ajaxPut', res.message, myUrl, res, data); // 记录日志
        callback(null);
      }
    });
  } catch (err) {
    that.fullscreenLoading = false;
    error(that, err.message);
    recordLog(that, 3, 'PUT/ajaxPut', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
};


/**
 * 以delete方式访问接口,删除
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxDelete = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.delete(myUrl, data, {
      params: data,
      that: that
    });
    that.$nextTick(() => {
      if (res.success == true) {
        if (res.data.result == true) {
          success(that, res.data.message);
          callback(res.data);
        } else {
          that.fullscreenLoading = false;
          warning(that, res.data.message);
          callback(null);
        }
      } else {
        recordLog(that, 3, 'DELETE/ajaxDelete', res.message, myUrl, res, data); // 记录日志
        callback(null);
      }
    });
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'DELETE/ajaxDelete', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
};

/**
 * 以get方式访问接口，查询
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPutToGet = async function (that, myUrl, data, callback) {
  try {
    if (myUrl != null && typeof (myUrl) != "undefined" && myUrl != "") {
      const res = await that.$request.put(myUrl, data, {
        that: that
      });
      that.$nextTick(() => {
        if (res.success == true) {
          callback(res.data);
        } else {
          recordLog(that, 3, 'PUT/ajaxPutToGet', res.message, myUrl, res, data); // 记录日志
          callback(null);
        }
      });
    } else {
      that.fullscreenLoading = false;
      callback(null);
    }
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'PUT/ajaxPutToGet', err.message, myUrl, err.stack.toString(), data); // 记录日志
    callback(null);
  }
};


/**
 * 以post方式访问接口，提交
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPostError = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post(myUrl, data, {
      that: that
    });
    that.$nextTick(() => {
      if (res.success == true) {
        if (res.data.result == true) {
          var reg = new RegExp(/^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/);
          if (!reg.test(res.data.message)) {
            success(that, res.data.message);
          } else {
            success(that, "新增成功");
          }
          callback(res.data);
        } else {
          that.fullscreenLoading = false;
          callback(res.data);
        }
      } else {
        that.fullscreenLoading = false;
        recordLog(that, 3, 'POST/ajaxPostError', res.message, myUrl, res, data); // 记录日志
      }
    });
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPostError', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};

/**
 * 无提示交互数据
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxPostForNoTip = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request.post(myUrl, data, {
      that: that
    })
    that.$nextTick(() => {
      if (res.success == true) {
        if (res.data.result == true) {
          callback(res.data);
        }
      } else {
        recordLog(that, 3, 'POST/ajaxPostForNoTip', res.message, myUrl, res, data); // 记录日志
      }
    });
  } catch (err) {
    error(that, err.message);
    that.fullscreenLoading = false;
    recordLog(that, 3, 'POST/ajaxPostForNoTip', err.message, myUrl, err.stack.toString(), data); // 记录日志
  }
};


/**
 * 获取ChatAI
 * @param {*} that
 * @param {*} myUrl
 * @param {*} data
 * @param {*} callback
 */
window.ajaxChatAI = async function (that, myUrl, data, callback) {
  try {
    const res = await that.$request({
      method: 'post',
      url: myUrl,
      data: data,
      that: that,
    });

    if (res.success == true) {
      callback(res);
    } else {
      recordLog(that, 3, 'POST/ajaxChatAI', res.data.message, myUrl, res.message, data); // 记录日志
    }
  } catch (err) {
    recordLog(that, 3, 'POST/ajaxChatAI', err.message, myUrl, err.message, data); // 记录日志
  }
};


/**
 * @description 记录错误日志到数据库
 * @param {Object} that
 * @param {Object} objStatus 错误类型。3：后端反馈错误日志，4：前端系統错误
 * @param {Object} objType 调用的方法
 * @param {Object} objMessage 错误信息
 * @param {Object} objApi 接口
 */
window.recordLog = function (that, objStatus, objType, objMessage, objApi, objData, objValue) {

  let isAxios = true;

  // 将 objMessage 转为字符串，防止 undefined 调用 indexOf 报错
  objMessage = (objMessage != null && typeof objMessage !== 'undefined') ? JSON.stringify(objMessage) : '';

  // 过滤不需要记入日志的错误信息
  let arrFilterMsg = ['服务器异常', '未登录授权', '角色未授权', 'Token 刷新失败', '正在重定向到登录页', 'Token 刷新返回失败'];
  if (arrFilterMsg.some(item => objMessage.indexOf(item) != -1)) {
    return false;
  }

  let errInfo = `<div><b>浏览器：</b>${JSON.stringify(onBrowserType())}</div><div><b>请求方法：</b>${objType}</div>`;

  if (!regNull(objApi)) {
    errInfo += `<div><b>接口：</b>${objApi}</div>`;
  }

  if (!regNull(objData)) {
    if (!regNull(objData.data)) {
      errInfo += `<div><b>错误信息：</b></div>`;

      Object.keys(objData.data).forEach((item, index) => {
        errInfo +=
          `<div class="ml-5"><b>${item}：</b>${JSON.stringify(Object.values(objData.data)[index])}</div>`;
      });
    } else {
      errInfo += `<div><b>错误信息：${JSON.stringify(objData)}</b></div>`;
    }
  }


  if (!regNull(objValue)) {
    errInfo += `<div><b>参数：</b>${JSON.stringify(objValue)}</div>`;
  }


  let tpParams = {
    message: '【Web】' + objMessage,
    logType: objStatus,
    url: window.location.href,
    stackTrace: errInfo,
  }

  var url = process.env.VUE_APP_BASE_API + '/api/log/postlog';
  that.$axios.post(
    url,
    tpParams
  ).then(res => { }).catch(err => { });

};



/**
 * @@description 显示浏览器版本
 */
window.onBrowserType = function () {

  // 正则表达式方式来判定user-agent字符串，得到当前访问浏览器（http代理）的版本
  var userAgent = navigator.userAgent
  var rMsie = /(msie\s|trident.*rv:)([\w.]+)/
  var rFirefox = /(firefox)\/([\w.]+)/
  var rOpera = /(opera).+version\/([\w.]+)/
  var rChrome = /(chrome)\/([\w.]+)/
  var rSafari = /version\/([\w.]+).*(safari)/
  var ua = userAgent.toLowerCase()
  var match = rMsie.exec(ua)

  if (match != null) {
    return {
      browser: 'IE',
      version: match[2] || '0'
    }
  }
  match = rFirefox.exec(ua)
  if (match != null) {
    return {
      browser: match[1] || '',
      version: match[2] || '0'
    }
  }
  match = rOpera.exec(ua)
  if (match != null) {
    return {
      browser: match[1] || '',
      version: match[2] || '0'
    }
  }
  match = rChrome.exec(ua)
  if (match != null) {
    return {
      browser: match[1] || '',
      version: match[2] || '0'
    }
  }
  match = rSafari.exec(ua)
  if (match != null) {
    return {
      browser: match[2] || '',
      version: match[1] || '0'
    }
  }
  if (match == null) {
    return {
      browser: '',
      version: '0'
    }
  }
}

